<template>
  <el-card style="margin-bottom:20px;">
    <div slot="header" class="clearfix title">
      <span>我的团队</span>
      <el-button type="text" @click="dialogVisible = true">切换团队</el-button>
    </div>

    <div class="user-profile">
      <div class="box-center">
        <pan-thumb :image="avatar" :height="'100px'" :width="'100px'" :hoverable="false" />
      </div>
      <div class="box-center">
        <div class="user-name text-center">{{ currentEnterprise.enterpriseName }}</div>
      </div>
    </div>

    <div class="user-bio">
      <div class="user-education user-bio-section">
        <div class="user-bio-section-header">
          <svg-icon icon-class="education" />
          <span>所在地</span>
        </div>
        <div class="user-bio-section-body">
          <div class="text-muted">{{ currentEnterprise.address }}</div>
        </div>
      </div>

      <!-- <div class="user-skills user-bio-section">
        <div class="user-bio-section-header">
          <svg-icon icon-class="skill" />
          <span>职员状态</span>
        </div>
        <div class="user-bio-section-body">
          <div class="progress-item">
            <span>在职</span>
            <el-progress :percentage="80" />
          </div>
          <div class="progress-item">
            <span>未激活</span>
            <el-progress :percentage="18" />
          </div>
          <div class="progress-item">
            <span>交接</span>
            <el-progress :percentage="12" />
          </div>
          <div class="progress-item">
            <span>离职</span>
            <el-progress :percentage="5" />
          </div>
        </div>
      </div>-->
    </div>

    <!-- 切换团队 -->
    <switch-enterprise v-model="dialogVisible" />
  </el-card>
</template>

<script>
import PanThumb from "@/components/PanThumb/PanThumb";
import SwitchEnterprise from "./SwitchEnterprise";
import { mapGetters } from "vuex";

export default {
  components: { PanThumb, SwitchEnterprise },

  computed: {
    ...mapGetters(["currentEnterprise", "avatar"])
  },

  data() {
    return {
      dialogVisible: false
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;

  .el-button {
    float: right;
    font-size: 14px;
    padding: 2px;
  }
}

.box-center {
  margin: 0 auto;
  display: table;
}

.text-muted {
  color: #777;
}

.user-profile {
  .user-name {
    font-weight: bold;
    font-size: 16px;
  }

  .box-center {
    padding-top: 10px;
  }

  .box-social {
    padding-top: 30px;

    .el-table {
      border-top: 1px solid #dfe6ec;
    }
  }

  .user-follow {
    padding-top: 20px;
  }
}

.user-bio {
  margin-top: 20px;
  color: #606266;

  span {
    padding-left: 4px;
  }

  .user-bio-section {
    font-size: 14px;
    padding: 15px 0;

    .user-bio-section-header {
      border-bottom: 1px solid #dfe6ec;
      padding-bottom: 10px;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
</style>
